import 'slick-carousel';
const TABLET_WIDTH = 1024
const MOBILE_WIDTH = 768

$('.js-slider-logos .slider__slides').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: true,
  responsive: [
    {
      breakpoint: TABLET_WIDTH,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: MOBILE_WIDTH,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});
